import Utils from "../utils/Utils";

const CountriesController = {
  getCountries: () => {
    return Utils.controller(
      "api/country/v1/countries",
      "",
      "GET",
      "",
      false,
      "",
      true,
    );
  },
};

export default CountriesController;
